import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "checkbox" }
const _hoisted_2 = { class: "checkbox__wrap" }
const _hoisted_3 = ["id", "value", "checked", "required", "disabled", "multiple"]
const _hoisted_4 = ["for"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Description = _resolveComponent("Description")!
  const _component_FieldError = _resolveComponent("FieldError")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("input", {
        id: _ctx.computedId,
        class: _normalizeClass(["checkbox__input", {
          'checkbox__input--disabled': _ctx.disabled,
          'checkbox__input--required': _ctx.required,
        }]),
        type: "checkbox",
        value: _ctx.computedValue,
        checked: _ctx.isChecked(),
        onInput: _cache[0] || (_cache[0] = ($event: any) => (_ctx.onChange($event))),
        required: _ctx.required,
        disabled: _ctx.disabled,
        onFocus: _cache[1] || (_cache[1] = ($event: any) => (_ctx.hasFocus = true)),
        onBlur: _cache[2] || (_cache[2] = ($event: any) => (_ctx.hasFocus = false)),
        multiple: _ctx.multiple
      }, null, 42, _hoisted_3),
      (_ctx.label)
        ? (_openBlock(), _createElementBlock("label", {
            key: 0,
            for: _ctx.computedId,
            class: _normalizeClass(["checkbox__label", {
          'checkbox__label--disabled': _ctx.disabled,
          'checkbox__label--required': _ctx.required,
        }])
          }, _toDisplayString(_ctx.label), 11, _hoisted_4))
        : _createCommentVNode("", true)
    ]),
    (Boolean(_ctx.description))
      ? (_openBlock(), _createBlock(_component_Description, {
          key: 0,
          class: "checkbox__description"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.description), 1)
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    _createVNode(_component_FieldError, { errorMessage: _ctx.errorMessage }, null, 8, ["errorMessage"])
  ]))
}